<template>
	
	<div class="mx-auto p-0 sm:p-4">
		<div class="mx-auto md:h-100% flex flex-col">
			<div class="btn-grup flex justify-between pb-3 border-b border-gray-3 mb-3 items-center">
				<button
					class="flex flex-row hover:bg-gray-4 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold hover:text-primary-500 transition-all bg-transparent border-gray-3 border text-primary"
					type="button" @click="handleBackButtonClick">
					<i class="tabler:arrow-left w-5 h-5 mr-1"></i>
					<span class="hidden md:inline">{{ labels.backbtn }}</span>
				</button>
			
				
			</div>
			<div v-for="quiz in validQuizeslistMode" :key="quiz.identifier"  class="bg-white shadow-sm rounded mb-4" style="border: 1px solid rgb(222, 222, 222, 0.5)">
				<!-- Title and Actions -->
				
					<div class="flex flex-col  sm:flex-row justify-center mt-3">
						<div class="px-4 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1 relative">
							<EditButton
								class="absolute right-5px top-[-5px] inline-flex items-center gap-2 transition-all rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center mr-2 font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								v-if=" AppConfig.editmode && quiz._links.mainOutcome " :id="quiz.identifier" type="listattr"
								:overrideURL="quiz._links.preQuiz.href" />
							<InplaceEdit
								:inputProps="[{ content: quiz.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
								:href="quiz._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true">
								<h6
									class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
									{{ quiz.mainOutcome.selectHeader }}
								</h6>
							</InplaceEdit>
							
							<div class="full-content">
								<div class="main-text md:line-clamp-3">
									<div class="flex items-center">
										<InplaceEdit
											:inputProps="[{ content: quiz.mainOutcome.title, propName: 'title', inputType: 'textarea' }]"
											:href="quiz._links.mainOutcomeEdit?.href" blockTitle="Edit title"  :showAssistant="true"
											:textarea-props="{ rows: 3, class: 'min-w-[30rem]' }">
												<h4
													class="mb-2 inline-flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased">
													{{ quiz.mainOutcome.title }}
												</h4>
										</InplaceEdit>
									</div>
								</div>
                                <div class="quiz-header mb-2">
								<!-- <strong class="ml-1">{{ quiz.packageTitle }}</strong> -->
								<div class="gap-3 flex items-center ">
										<InplaceEdit
											:inputProps="[
												{
													content: quiz.mainOutcome.publishingDate,
													propName: 'other.publishingDate',
													inputType: 'datepicker',
												},
											]"
											:href="quiz._links.mainOutcomeEdit?.href"
											blockTitle="Edit publishing date"
										>
											<div class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated(quiz.mainOutcome.publishingDate) }}
											</div>
										</InplaceEdit>
										<InplaceEdit
											:inputProps="[
												{
													content: quiz.mainOutcome.authorIdentifier,
													propName: 'other.authorIdentifier',
													inputType: 'select',
													selectProps: {
														optionValue: 'identifier',
														optionLabel: 'title',
														class: 'w-15rem',
														optionsCvKey: 'author',
													},
												},
											]"
											:href="quiz._links.mainOutcomeEdit?.href"
											blockTitle="Edit author"
										>
											<div class="ml-2 text-sm font-bold" v-html="quiz.mainOutcome.author"></div>
										</InplaceEdit>
									</div>
							</div>
								<div v-if="globalQuizMode !== 'post'">
									<PreQuiz :jsonData="quiz" :overrideURL="quiz?._links.preQuiz?.href" :selectedLanguage='selectedLanguage' />
								</div>
								<div v-else>
									<PostQuiz :jsonData="quiz" :overrideURL="quiz?._links.postQuiz?.href" :selectedLanguage='selectedLanguage' />
								</div>
							</div>

						</div>
					</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios'
import { DateTime } from 'luxon';

import { useAppConfig } from '@/composables/useAppConfig';

import type { Callout, ListFilters, PostListResponse } from '@/types';
import EditButton from '@/components/EditButton.vue'
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue'
import PreQuiz from '@/components/PreQuiz.vue'
import PostQuiz from '@/components/PostQuiz.vue'


import { messages } from '@/assets/language';
import { useAppStore } from '@/stores/app-store';
import { toArrayParam } from '@/utils/requestParams';

const { currentLng, currentMedicalFilter, currentStudyType, currentoutcomeType, currenttargetAudience, currentPublishingFilter, currentAuthoringFilter } = useAppStore()
const AppConfig = useAppConfig();

const route = useRoute();
const router = useRouter();

const labels = computed(() => {
	const key = currentLng.value as keyof typeof messages;
	return messages[key] ?? {};
});

// ✅ E përditësuar për të kthyer te faqja e listës me query filters
const handleBackButtonClick = () => {
	router.push({ name: 'quizes', query: { ...route.query } });
};

const defaultFIlters = () => ({
	search: null,
	author: [],
	outcomeType: [],
	targetAudience: [],
	inputMaterialType: []
});
const listFilters = ref<ListFilters>(defaultFIlters());

withDefaults(defineProps<{
	selectedLanguage: string
}>(), {
	selectedLanguage: 'en'
})


const quizeslistMode = ref<Callout[]>([]);
const validQuizeslistMode = computed(() => {
	if (!Array.isArray(quizeslistMode.value)) return [];
	const id = route.params.id;
	if (!id) return quizeslistMode.value;
	return quizeslistMode.value.filter((quiz: any) => quiz.identifier === id);
});

const globalQuizMode = ref<'pre' | 'post'>('pre');

function publishingDateFormated(publishingDate?: string) {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  };
  if (!publishingDate) {
    return formatDate(new Date());
  }
  const dateTime = DateTime.fromISO(publishingDate);
  if (!dateTime.isValid) {
    return formatDate(new Date());
  }
  return formatDate(dateTime.toJSDate());
}

onMounted(async () => {
	try {
			let params: Record<string, any> = {
				...route.query,
				...listFilters.value,
				lng: currentLng.value,
			};
			delete params.currentStudyType;
			delete params.studyType;
			delete params.studyTpe;
			delete params.studyMode;

		if (currentMedicalFilter.value) {
			params.medicalSpeciality = currentMedicalFilter.value;
		}
		if (currentPublishingFilter.value) {
			params.publishingStatus = currentPublishingFilter.value;
		}
		if (currentAuthoringFilter.value) {
			params.authoringStatus = currentAuthoringFilter.value;
		}

			if (currentStudyType.value) {
				params.studyType = currentStudyType.value;
			}
		if (currentoutcomeType.value) {
			params.outcomeType = currentoutcomeType.value;
		}
		const targetAudienceParam = toArrayParam(currenttargetAudience.value);
		if (targetAudienceParam.length) {
			params.targetAudience = targetAudienceParam;
		}

		const response = await axios.get<PostListResponse>(`${AppConfig.urls.getList}?json=y`, {
			params: params,
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest',
				'Accept-Language': currentLng.value
			}
		});

		const jsonData = response.data;
		if (Array.isArray(jsonData.data)) {
			quizeslistMode.value = jsonData.data;
			// console.log('quizeslistMode loaded:', quizeslistMode.value);
		} else {
			console.error('Expected an array but received:', jsonData.data);
			quizeslistMode.value = [];
		}
	} catch (error) {
		console.error('Failed to fetch data:', error);
	}
});


</script>


<style>
</style>
